module.exports = __webpack_public_path__ + "static/media/capsule_machine_hk_ori_3.f98494f5.png";